<template>
  <div class="m-level">
    <span class="m-rank__title">Level:</span>
    <span class="m-level_number">{{ getLevel }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['getLevel']),
  },
  methods: {
    // increaseRank() {
    //   this.$store.state.user.rank += 1;
    //   return this.$store.state.user.rank;
    // },
    // decreaseRank() {
    //   this.$store.state.user.rank -= 1;
    //   return this.$store.state.user.rank;
    // },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/header/Level.vue